module.exports = __webpack_public_path__ + "img/dodenherdenking-1.7826666b.jpg";